// extracted by mini-css-extract-plugin
var _1 = "UserResultCard-module__footer--WN4Lr";
export { _1 as "footer" }
